export default function LiveTag() {
  return (
    <div
      className={`absolute font-inter text-[13px] bg-red-500 font-semibold text-white rounded-[4px] px-[5px] select-none top-[10px] left-[10px]`}
    >
      LIVE
    </div>
  )
}
